export const PRODUCT_DETAIL_CAPITAL = 'PRODUCT_DETAIL_CAPITAL';
export const HOME = 'HOME';
export const HOME_POP_UP = 'HOME_POP_UP';
export const PRODUCT_DETAIL = 'PRODUCT_DETAIL';
